import { render, staticRenderFns } from "./ContactMe.vue?vue&type=template&id=58885b82&scoped=true&"
import script from "./ContactMe.vue?vue&type=script&lang=js&"
export * from "./ContactMe.vue?vue&type=script&lang=js&"
import style0 from "./ContactMe.vue?vue&type=style&index=0&id=58885b82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58885b82",
  null
  
)

export default component.exports